import { Fragment, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { getAdminPatients } from '../../actions/patientActions';
import { clearPatient } from '../../slices/patientSlice';
import Loader from '../layouts/Loader';
import { MDBDataTable } from 'mdbreact';
import Sidebar from '../Dashboard/Sidebar';

const formatCurrency = (n) =>
  '₹' + Number(n || 0).toLocaleString('en-IN', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

export default function PatientList() {
  const { patients = [], loading = true } = useSelector(state => state.patientsState);
  const dispatch = useDispatch();
  const { user } = useSelector(state => state.authState);
  const isAdmin = user?.role === 'admin' || user?.role === 'master';
  const canAddPatient = isAdmin || user?.role === 'doctor';

  const setPatients = () => {
    const data = {
      columns: [
        { label: 'ID',      field: 'id',      sort: 'asc' },
        { label: 'Name',    field: 'name',    sort: 'asc' },
        { label: 'Phone',   field: 'phone',   sort: 'asc' },
        { label: 'Address', field: 'address', sort: 'asc' },
        { label: 'Total Billed', field: 'totalBilled', sort: 'asc' },
        { label: 'Actions', field: 'actions', sort: 'asc' },
      ],
      rows: [],
    };

    patients.forEach(patient => {
      const row = {
        id:      patient.patientId,
        name:    patient.name,
        phone:   patient.phone,
        address: patient.address || '—',
        totalBilled: (
          <span
            className="fw-semibold"
            style={{
              color: Number(patient.totalBilled || 0) > 0 ? 'var(--primary)' : 'var(--text-muted)'
            }}
          >
            {formatCurrency(patient.totalBilled)}
          </span>
        ),
        actions: (
          <Fragment>
            <Link
              to={`/patient/${patient.patientId || patient._id || patient.id}`}
              className="btn btn-sm me-2"
              style={{
                background: 'rgba(59,130,246,0.1)',
                color: '#3b82f6',
                border: '1px solid rgba(59,130,246,0.25)',
                borderRadius: '6px',
              }}
            >
              <i className="fa fa-eye"></i>
            </Link>
            {isAdmin && (
              <Link
                to={`/admin/patient/${patient.patientId || patient._id || patient.id}`}
                className="btn btn-sm"
                style={{
                  background: 'rgba(13,148,136,0.1)',
                  color: 'var(--primary)',
                  border: '1px solid rgba(13,148,136,0.25)',
                  borderRadius: '6px',
                }}
              >
                <i className="fa fa-pencil"></i>
              </Link>
            )}
          </Fragment>
        ),
      };
      data.rows.push(row);
    });

    return data;
  };

  useEffect(() => {
    dispatch(getAdminPatients());
    dispatch(clearPatient());
  }, [dispatch]);

  return (
    <div className="row g-0">
      <div className="col-12 col-md-2"><Sidebar /></div>
      <div className="col-12 col-md-10 main-content">
        <div className="d-flex justify-content-between align-items-center mb-4 flex-wrap gap-2">
          <div>
            <h1 className="mb-0 fw-bold" style={{ fontSize: '1.5rem' }}>Patients</h1>
            <p className="mb-0 mt-1" style={{ color: 'var(--text-muted)', fontSize: '0.875rem' }}>
              {patients.length} patient{patients.length !== 1 ? 's' : ''} registered
            </p>
          </div>
          {canAddPatient && (
            <Link to="/admin/newpatient" className="btn btn-primary">
              <i className="fa fa-user-plus me-2"></i>Add Patient
            </Link>
          )}
        </div>

        <div className="card">
          <div className="card-body p-3">
            {loading ? (
              <Loader />
            ) : (
              <MDBDataTable
                data={setPatients()}
                bordered
                hover
                responsive
                className="px-2"
                style={{ fontSize: '0.875rem' }}
              />
            )}
          </div>
        </div>
      </div>
      </div>
  );
}


